// ============
//   RuleSet
// ============

function RuleSet(name) {
    this.name = name;
    this.rules = [];
}

RuleSet.prototype.getRules = function () {
    return this.rules;
};

RuleSet.prototype.addRule = function (rule) {
    this.rules.push(rule);
};

export default RuleSet;
